'use strict';

import 'fancybox'
import '../../_assets/abbott/js/_modernizr';

export default class Modal {
    constructor() {
        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        if ($('.modal').length) {
            $.fancybox.open('#generic', {
                autoSize: false,
                closeBtn: false,
                fitToView: false,
                height: isMobileDevice == true ? 300 : 200,
                width: isMobileDevice == true ? 250 : 500,
                padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
                type: 'inline',
                wrapCSS: 'modal'
            });
        }

        $('body').on('click', '.js-fancybox-close', function () {
            $.fancybox.close();
        });
    }
}
